export enum NavbarOptions {
  MY_GEM_VAULT = 'myGemVAULT™',
  MY_GEM_FAV = 'myGemFAV™',
  POROLIS_GEM_BANK = 'Porolis GemBANK™',
}
